export const filterTrueValues = obj => Object.keys(obj).filter(key => obj[key]);
